/*
 * @Author: changcheng
 * @LastEditTime: 2023-08-17 16:01:36
 */
import { Outlet } from "react-router-dom";
export default function CourseTrain() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
